import type { GameState } from '../state/gameState';
import type { GameEmitter } from '../events';
import type { PowerUpKind } from '../types';
import { ARENA, POWERUPS } from '../config/gameConfig';

/** Start a power-up's effect clock. Shared by projectile pickup and walk-in. */
export function applyPowerUp(state: GameState, kind: PowerUpKind, emit: GameEmitter, position: { x: number; y: number; z: number }): void {
  const until = state.elapsed + POWERUPS.duration[kind];
  if (kind === 'timeFreeze') state.effects.timeFreezeUntil = until;
  else if (kind === 'multiShot') state.effects.multiShotUntil = until;
  else state.effects.hintUntil = until;
  emit.emit('powerUpCollected', { kind, position: { ...position } });
}

// Drifts power-up stars toward the player; reaching the player collects them
// (kid-friendly — shooting them just collects them sooner, see projectile
// system). Time freeze does not stop the stars: gifts keep coming.
export function updatePowerUpSystem(state: GameState, dt: number, emit: GameEmitter): void {
  const player = ARENA.playerPosition;
  for (let i = state.powerups.length - 1; i >= 0; i--) {
    const p = state.powerups[i];
    const dx = player.x - p.position.x;
    const dy = player.y - p.position.y;
    const dz = player.z - p.position.z;
    const distSq = dx * dx + dy * dy + dz * dz;
    if (distSq > 1e-16) {
      const step = (p.speed * dt) / Math.sqrt(distSq);
      p.position.x += dx * step;
      p.position.y += dy * step;
      p.position.z += dz * step;
    }
    if (distSq < ARENA.collisionRadius * ARENA.collisionRadius) {
      state.powerups.splice(i, 1);
      applyPowerUp(state, p.kind, emit, p.position);
    }
  }
}
